// extracted by mini-css-extract-plugin
export default {"description":"WeatherDescription_description__Vl73K"};